'use client'
import Script from 'next/script'
import { useEffect } from 'react'
import { useUser } from 'web/hooks/use-user'
import { getSupabaseBrowserClient } from 'web/lib/supabase/client'

async function handleResponse(response: any) {
  const idToken = response.credential
  try {
    const supabase = getSupabaseBrowserClient()
    const { data, error } = await supabase.auth.signInWithIdToken({
      provider: 'google',
      token: idToken,
    })
    if (error) throw error
    console.log('Google One Tap login success:', data.user?.email)
  } catch (error) {
    console.error('Could not log in via Google One Tap:', error)
  }
}

const initGSI = () => {
  ;(window as any).google?.accounts.id.initialize({
    client_id:
      '128925704902-bpcbnlp2gt73au3rrjjtnup6cskr89p0.apps.googleusercontent.com',
    callback: handleResponse,
    itp_support: true,
    prompt_parent_id: 'signup-prompt',
  })
}

export const GoogleOneTapSetup = () => {
  useEffect(() => {
    setTimeout(() => initGSI(), 500)
  }, [])

  return <Script src="https://accounts.google.com/gsi/client" />
}

export const GoogleOneTapLogin = (props: { className?: string }) => {
  const user = useUser()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!user && (window as any).google?.accounts?.id?.prompt) {
        ;(window as any).google.accounts.id.prompt()
      }
    }, 1000)

    return () => clearTimeout(timeoutId)
  }, [user])

  return <div id="signup-prompt" className={props.className} />
}
